import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vouchesComponent from './vouches.component';

let vouchesModule = angular.module('app.containers.vouches', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('vouches', {
      url: '/vouches',
      template: '<vouches></vouches>'
    });
})

.component('vouches', vouchesComponent);

export default vouchesModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/vouches/vouches.js
 **/